export default {
  adapters: {
    breadcrumbs: {
      editorial: {
        home: 'Úvod'
      },
      ugr: {
        home: 'Úvod'
      },
      recipes: {
        home: 'Recepty'
      }
    },
    cards: {
      userCollection: {
        savedItemDescription_one: 'položka',
        savedItemDescription_few: 'položky',
        savedItemDescription_many: 'položek',
        savedItemDescription_other: 'položek',
        savedItemDescription: 'položka',
        savedItemDescription_plural: 'položek',
        savedItemDescription_0: 'položka',
        savedItemDescription_1: 'položky',
        savedItemDescription_2: 'položek'
      },
      userRecipe: {
        statusTextDraft: 'Koncept receptu',
        statusApproved: 'Uživatelský recept',
        statusPending: 'Čeká na schválení',
        statusRejected: 'Recept zamítnut'
      }
    },
    iconAdapter: {
      formatTimeHours_one: '{{hours}} hod',
      formatTimeHours_few: '{{hours}} hod',
      formatTimeHours_many: '{{hours}} hod',
      formatTimeHours_other: '{{hours}} hod',
      formatTimeHours: '{{hours}} hod',
      formatTimeHours_plural: '{{hours}} hod',
      formatTimeHours_0: '{{hours}} hod',
      formatTimeHours_1: '{{hours}} hod',
      formatTimeHours_2: '{{hours}} hod',
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} min',
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    pageSchema: {
      editorial: {
        recipe: {
          calories: '{{calories}} energie',
          carbContent: '{{carbs}} g sacharidů',
          fatContent: '{{fat}} g tuků',
          fibreContent: '{{fibre}} g vlákniny',
          proteinContent: '{{protein}} g bílkovin',
          satFatContent: '{{saturates}} g nasycených tuků',
          sodiumContent: '{{sodium}} mg sodíku',
          sugarContent: '{{sugars}} g cukru'
        }
      },
      ugr: {
        servesDefault: 'Porce'
      }
    },
    post: {
      ugr: {
        messageMember: 'Uživatelský recept',
        messageOther: '{{status}} receptu',
        statuses: {
          draft: 'Návrh',
          approved: 'Schváleno',
          rejected: 'Zamítnuto',
          pending: 'Nevyřízeno',
          published: 'Publikováno'
        }
      }
    },
    posts: {
      editorial: {
        list: {
          seeMoreText: 'Zobrazit více'
        },
        liveBlog: {
          hour_one: 'před hodinou',
          hour_few: 'před hodinami',
          hour_many: 'před hodinami',
          hour_other: 'před hodinami',
          hour: 'před hodinou',
          hour_plural: 'před hodinami',
          hour_0: 'před hodinou',
          hour_1: 'před hodinami',
          hour_2: 'před hodinami',
          lessThanHour_one: 'před minutou',
          lessThanHour_few: 'před minutami',
          lessThanHour_many: 'před minutami',
          lessThanHour_other: 'před minutami',
          lessThanHour: 'před minutou',
          lessThanHour_plural: 'před minutami',
          lessThanHour_0: 'před minutou',
          lessThanHour_1: 'před minutami',
          lessThanHour_2: 'před minutami',
          lessThanMinute: 'před méně než minutou',
          updatedMessageLive: 'aktualizováno ŽIVĚ',
          updatedMessageNotLive: 'aktualizováno'
        }
      },
      postAdapter: {
        callout: 'Toto je {{status}} {{entity}}',
        previewCallout: 'Náhled',
        recommendedTitle: 'Více podobných receptů',
        statuses: {
          draft: 'Návrh',
          approved: 'Schváleno',
          rejected: 'Zamítnuto',
          pending: 'Nevyřízeno',
          preview: 'náhled',
          published: 'Publikováno'
        },
        entities: {
          glossary: 'Glosář',
          howTo: 'Jak na to',
          editorialList: 'Redakční sbírka',
          plant: 'Rostlina',
          post: 'Článek',
          recipe: 'recept',
          review: 'Recenze',
          'broadcast-show': 'Vysílání',
          venue: 'Místo',
          page: 'Stránka',
          'user-collection': 'Kolekce uživatele',
          blog: 'Živý blog'
        }
      },
      recipeAdapter: {
        getPublicationMessage: 'Recept od',
        labels: {
          carbs: 'carbs',
          fat: 'fat',
          fibre: 'fibre',
          kcal: 'kcal',
          protein: 'protein',
          salt: 'salt',
          saturates: 'saturates',
          sugars: 'sugars'
        },
        nutritionHighInPrefix: 'bohatý na',
        nutritionLabel: 'Nutriční hodnoty',
        nutritionLowInPrefix: 's nízkým obsahem',
        planning: {
          'easily-doubled': 'Lsz snadno znásobit',
          'easily-halved': 'Lsz snadno připravit poloviční množství',
          freezable: 'Vhodné k zamražení'
        },
        recommendedAltTitle: 'Naše nejoblíbenější alternativy',
        servingsLabel_one: 'Porce {{count}}',
        servingsLabel: 'Porce {{count}}',
        servingsLabel_range: 'Porce {{min}} - {{max}}'
      },
      userRecipeAdapter: {
        categoryDisplay: 'Recepty'
      }
    },
    sponsorTracking: {
      label: 'Reklama'
    },
    pageBlocks: {
      riddle: {
        errorMessage: 'There seems to be an issue with the quiz, please try again.'
      }
    }
  },
  controllers: {
    archives: {
      taxonomyDataDisplayLabel: {
        age: 'Age',
        'date-of-birth': 'Date of birth',
        'comes-from': 'Comes from',
        'known-for': 'Known for',
        occupation: 'Occupation',
        'sign-of-the-zodiac': 'Sign of the Zodiac',
        parents: 'Parents',
        spouse: 'Spouse',
        biography: 'Biography'
      }
    },
    search: {
      modifyFilterOptions: {
        transform: {
          time: {
            // v4 plural
            hour_one: '{{hours}} hodina',
            hour_few: '{{hours}} hodiny',
            hour_many: '{{hours}} hodin',
            hour_other: '{{hours}} hodin',
            // v3 plural
            hour: '{{hours}} hodina',
            hour_plural: '{{hours}} hodin',
            hour_0: '{{hours}} hodin',
            hour_1: '{{hours}} hodina',
            hour_2: '{{hours}} hodiny',
            // v4 plural
            minute_one: '{{minutes}} minuta',
            minute_few: '{{minutes}} minuty',
            minute_many: '{{minutes}} minuty',
            minute_other: '{{minutes}} minuty',
            // v3 plural
            minute: '{{minutes}} minuta',
            minute_plural: '{{minutes}} minuty',
            minute_0: '{{minutes}} minuty',
            minute_1: '{{minutes}} minuta',
            minute_2: '{{minutes}} minuty',
            gte: '{{time}} nebo více',
            gt: 'Více než {{time}}',
            lte: '{{time}} nebo méně',
            lt: 'Méně než {{time}}'
          },
          calories: {
            gteOrGt: 'Nad {{calories}} kcal',
            lteOrLt: 'Do {{calories}} kcal'
          }
        }
      },
      siteSearchConfig: {
        facet: {
          label: {
            author: 'Autor',
            calories: 'Kalorie',
            category: 'Kategorie',
            cuisine: 'Kuchyně',
            diet: 'Dieta',
            difficulty: 'Obtížnost',
            mealType: 'Typ jídla',
            occasion: 'Příležitost',
            ratings: 'Hodnocení',
            servings: 'Porce',
            totalTime: 'Celkový čas'
          }
        },
        filter: {
          label: {
            recipe: 'Recepty',
            video: 'Video',
            guides: 'Návody',
            collection: 'Kolekce receptů',
            glossary: 'Slovníček',
            review: 'Hodnocení'
          }
        },
        sortOptions: {
          label: {
            published: 'Poslední přidané',
            quickest: 'Nejrychlejší',
            rating: 'Nejpopulárnější',
            relevant: 'Nejrelevantnější'
          }
        }
      }
    }
  }
};